import { ClosingControlState } from "../types/closing-control.type";

/**
 * Garante que o rótulo de fluxo só exista quando há closingStatus definido.
 * A API pode enviar closingStatusLabel espelhando o headerButton por engano.
 */
export function normalizeClosingControlState(
  state: ClosingControlState | undefined,
): ClosingControlState | undefined {
  if (!state) {
    return state;
  }

  if (state.closingStatus === null) {
    return {
      ...state,
      closingStatusLabel: null,
    };
  }

  return state;
}

export function isProjectAdmin(
  roleName: string | undefined,
  roleId: string | undefined,
): boolean {
  return roleId === "USER_ADMINISTRATOR" || roleName === "Administrador";
}

/**
 * Administrador herda as permissões do Financeiro e da Operação conforme o
 * status do fechamento. A API continua sendo a fonte do status; o admin apenas
 * garante canEditClosing/headerButton coerentes com o fluxo ativo.
 */
export function resolveClosingControlState(
  state: ClosingControlState | undefined,
  isAdmin: boolean,
): ClosingControlState | undefined {
  const normalizedState = normalizeClosingControlState(state);

  if (!normalizedState || !isAdmin) {
    return normalizedState;
  }

  if (normalizedState.closingStatus === "PRE_CLOSING") {
    return {
      ...normalizedState,
      canEditClosing: true,
      headerButton: "RETURN",
    };
  }

  if (
    normalizedState.closingStatus === "RETURNED_FOR_ADJUSTMENTS" ||
    normalizedState.closingStatus === null
  ) {
    return {
      ...normalizedState,
      canEditClosing: true,
      headerButton: "PRE_CLOSING",
    };
  }

  return {
    ...normalizedState,
    canEditClosing: true,
  };
}
